const FOCUSABLE_SELECTOR = 'input:not([disabled]):not([type="hidden"]):not([readonly]):not([tabindex="-1"]),' +
    'textarea:not([disabled]):not([readonly]):not([tabindex="-1"]),' +
    'select:not([disabled]):not([tabindex="-1"]),' +
    '[role="combobox"]:not([disabled]):not([tabindex="-1"]),' +
    '[role="textbox"]:not([disabled]):not([tabindex="-1"])';
/**
 * Sposta il focus al prossimo elemento tabbabile nel documento.
 * Usato dal comportamento "Enter → next field" delle griglie editabili.
 */
export const focusNextFocusable = (current) => {
    const all = Array.from(document.querySelectorAll(FOCUSABLE_SELECTOR));
    const idx = all.indexOf(current);
    if (idx >= 0 && idx + 1 < all.length) {
        all[idx + 1].focus();
    }
};
/** I campi di form attivi: la base di ogni ricerca del «primo campo». */
const FORM_FIELD_SELECTORS = [
    'input:not([type="hidden"]):not(:disabled)',
    'textarea:not(:disabled)',
    'select:not(:disabled)',
];
/**
 * Il primo campo attivo dentro `root`, nell'ordine del documento, per il
 * focus all'apertura di un pannello (SheetView, pannello Filtri). `extra`
 * aggiunge i controlli che quel contenitore considera campi (es. combobox).
 */
export function findFirstField(root, extra = []) {
    return root.querySelector([...FORM_FIELD_SELECTORS, ...extra].join(', '));
}
//# sourceMappingURL=focus.js.map